
import XHeader from 'vux/src/components/x-header/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import DueDay from '@/components/ui/DueDay'

export default {
  directives: {
    TransferDom
  },
  components: {
    Group,
    Cell,
    Loading,
    XHeader,
    DueDay
  },
  methods: {
    courseById (id) {
      return this.$store.getters.keyedCourses[id] || {}
    }
  },
  computed: {
    todayTodos () {
      return this.$store.state.todoHomeworks.filter(hw =>
        (hw.create_date === this.$store.state.weekDate && this.courseById(hw.course_instance_id).course))
        .map(hw => {
          hw.hasAttachment = hw.attachment_filename && true
          return hw
        })
    },
    dueTodos () {
      return this.$store.state.todoHomeworks
        .filter(hw =>
          (hw.create_date !== this.$store.state.weekDate && this.courseById(hw.course_instance_id).course))
        .map(hw => {
          hw.hasAttachment = hw.attachment_filename && true
          return hw
        })
    }
  },
  created () {
    this.$store.dispatch('load', ['allCourses', 'todoHomeworks'])
      .then(() => { this.$vux.loading.hide() })
  },
  mounted () {
    this.$vux.loading.show()
  }
}




// WEBPACK FOOTER //
// ./src/components/HomeworkList.vue